import React from "react";
import "./styles.css";

import { Router } from "@reach/router";
import { Home } from "./pages/Home";
import { Editor } from "./pages/Editor";
import { Gist } from "./pages/Gist";

export function App() {
  return (
    <div className="App">
      <Router basepath={process.env.PARCEL_BASE_PATH || "/"}>
        <Home path="/" />
        <Editor path="editor" />
        <Gist path="gist/*" />
      </Router>
    </div>
  );
}
